/* frete-prazo.js — extrai a mensagem de chegada pronta do FreteFlow.

   O FreteFlow já devolve "Chega hoje / Chega amanhã / Chega segunda-feira" no campo
   `description` da taxa, calculada com o cutoff e os feriados DELE (fonte operacional).
   Aqui só validamos que é uma mensagem de chegada ("Chega ...") e a repassamos pro
   destaque. Taxas sem esse formato (ex.: Expresso "Entrega até 26-Jun") retornam null
   e seguem exibindo o prazo em dias úteis.

   Usado pelo módulo de cotação (assets/frete-cotacao.js — PDP v2, Duna, carrinho)
   e pelo calculador antigo (assets/shipping-calculator.js). Carregado global em
   snippets/head.liquid, junto com assets/frete-prazo.css (o destaque visual). */
(function () {
  window.fretePrazoChegada = function (rate) {
    var d = rate && rate.description ? String(rate.description).trim() : '';
    return /^chega\b/i.test(d) ? d : null;
  };

  /* Prazo em dias, para as taxas que NÃO trazem a mensagem de chegada acima.

     Mostra só o TETO: "até 6 dias úteis". Antes montávamos a faixa inteira,
     "{mín} a {máx} dias úteis", e isso quebrou quando o carrier começou a
     devolver 0 como mínimo para CEPs com entrega no mesmo dia: a vitrine passou
     a exibir "0 a 6 dias úteis" (Mario, print de 09/ago). O formato nunca mudou
     no tema — foi o dado que mudou.

     O piso da faixa não serve pra nada aqui de qualquer jeito. Ele é o melhor
     caso, quase nunca acontece, e o cliente lê a primeira metade como promessa.
     O que ele precisa saber é a data em que pode contar com o produto, que é o
     teto. "Até" também nunca promete a menos do que o carrier entrega.

     Esta função é a ÚNICA dona do texto: os dois calculadores da loja montavam a
     frase por conta própria, com o mesmo código copiado, então uma correção
     nascia sempre pela metade.

     Zero no teto (entrega no mesmo dia sem a mensagem pronta do FreteFlow) vira
     "no mesmo dia": "até 0 dias úteis" não quer dizer nada. */
  window.fretePrazoDias = function (rate) {
    var dias = rate && rate.delivery_days;
    if (!Array.isArray(dias)) return '';
    var mx = null;
    for (var i = 0; i < dias.length; i++) {
      var d = Number(dias[i]);
      // Guarda contra null/'' no meio do array: Number('') é 0 e Math.max com
      // um NaN contamina o resultado inteiro.
      if (dias[i] == null || dias[i] === '' || !isFinite(d)) continue;
      if (mx === null || d > mx) mx = d;
    }
    if (mx === null) return '';
    if (mx <= 0) return 'no mesmo dia';
    return 'até ' + mx + (mx > 1 ? ' dias úteis' : ' dia útil');
  };

  /* Dedup defensivo das tarifas de /cart/shipping_rates.json.

     O carrier (FreteFlow → gateway Frete Barato) às vezes devolve a MESMA modalidade
     duas vezes com o MESMO `code` — uma com preço e uma zerada. A linha "Grátis" é
     fantasma: o checkout colapsa tarifas de code idêntico e cobra a paga (ex.: Magalog
     R$23,90 + Magalog R$0,00 → checkout cobra 23,90). Aqui colapsamos por `code`
     mantendo o MAIOR preço (= o que o checkout cobra), preservando a ordem original.
     Só afeta DUPLICATAS de mesmo code: uma tarifa grátis LEGÍTIMA (code próprio) fica
     intacta, e serviços distintos (codes diferentes) seguem todos aparecendo. */
  window.freteDedupeRates = function (rates) {
    if (!Array.isArray(rates)) return rates || [];
    var keyOf = function (rt) { return rt && (rt.code || rt.presentment_name || rt.name || ''); };
    var best = {};
    rates.forEach(function (rt) {
      var k = keyOf(rt);
      if (!best[k] || Number(rt.price) > Number(best[k].price)) best[k] = rt;
    });
    var seen = {}, out = [];
    rates.forEach(function (rt) {
      var k = keyOf(rt);
      if (seen[k]) return;
      seen[k] = true;
      out.push(best[k]);
    });
    return out;
  };
})();
